import { useAdminMe } from "./useAdminMe.js";

export const useWorkspaceId = () => {
  const q = useAdminMe();
  return {
    workspaceId: q.data?.activeWorkspaceId ?? null,
    isLoading: q.isLoading,
    isError: q.isError,
    refetchMe: q.refetch
  };
};

/** Active workspace row from /admin/me (name, slug, id). */
export const useCurrentWorkspace = () => {
  const q = useAdminMe();
  const workspaceId = q.data?.activeWorkspaceId ?? null;
  const workspace =
    workspaceId === null ? null : (q.data?.workspaces.find((w) => w.id === workspaceId) ?? null);
  return {
    workspaceId,
    workspaceName: workspace?.name ?? null,
    workspaceSlug: workspace?.slug ?? null,
    isLoading: q.isLoading,
    isError: q.isError
  };
};
